import React from "react";

import Spinner from "components/library/Spinner";
import styles from "./EditorLoading.css";

export default function EditorLoading() {
  return (
    <div className={styles.root}>
      <Spinner />
    </div>
  );
}
